import ApiBase from "../api-base";

export  default class ApplicationApi extends ApiBase {

    async create(grantId, eligibility, validationHandler = this.defaultValidationHandler) {
        const response = await this.post('/applications', {
            grant_id : grantId,
            eligibility,
        });

        return response.data.data;
    }
    async deleteApplication(applicationId, validationHandler = this.defaultValidationHandler) {
        const response = await this.delete(`/applications/${applicationId}`, {});

        return response.data.data;
    }

    async history() {
        const response = await  this.get('/applications/history');

        return response.data;
    }

    async applicationHistory(id, page, per_page) {
        const response = await this.get(`/applications/${id}/history`, {params: {page, per_page}});

        return response.data;
    }

    async getApplications() {
        const response = await this.get('/applications');

        return response.data.data;
    }

    async getApplication(id) {
       const response =  await this.get(`/applications/${id}`);
       return response.data.data;
    }

    async addFile(id, file) {
        const response =  await this.post(`/applications/${id}files`, file);

       return response.data.data;
    }

    async deleteFile(applicationId, fileId) {
        const response = await this.delete(`/applications/${applicationId}/files/${fileId}`);
        return response.data;
    }

    async update(id, params, validationHandler = this.defaultValidationHandler) {
        return this.handleResponse(async () => {
            const response = await this.post(`/applications/${id}`, params, validationHandler, false);

            return response.data.data;
        });
    }

    async submit(id, params, validationHandler = this.defaultValidationHandler) {
        return this.handleResponse(async () => {
            const response = await this.post(`/applications/${id}/complete`, params, validationHandler, false);

            return response.data.data;
        });
    }

    async getComments(id, page = 1, per_page = 100, question_id = null) {

        return this.handleResponse(async () => {
            let response = await this.get(`/applications/${id}/comments`, { page, per_page, question_id });

            return response.data;
        });
    }

    async postComments(id, params) {
        return this.handleResponse(async () => {
            let response = await this.post(`/applications/${id}/comments`, params);

            return response.data.data;
        });
    }

    async markAsRead(id, ids = []) {
        return this.handleResponse(async () => {
            let response = await this.post(`/applications/${id}/comments/mark-read`, {
                application_comment_ids: ids
            });

            return response.data.data;
        });
    }

    async getAmends(id) {
        return this.handleResponse(async () => {
            let response = await this.get(`/applications/${id}/amendments`);

            return response.data.data;
        });
    }

    async submitAmends(id, params, validationCallback = () => {}) {
        return this.handleResponse(async () => {
            let response = await this.post(`/applications/${id}/amendments/submit`, params, validationCallback);

            return response.data.data;
        });
    }
}
